import React from 'react';

import { useTranslation } from 'react-i18next';

import { RailzButton } from '@railzai/railz-uikit-react';

import useStyle from '../style';

import Status from './status';
import RelatedIntegrations from './related-integrations';

import { AllBusinessStatus } from 'pages/business/types/enums';

export interface BusinessControlsProps {
  setSelectedStatus: React.Dispatch<React.SetStateAction<AllBusinessStatus>>;
  selectedStatus: AllBusinessStatus;
  applyFilter: () => void;
  integrationUuids: string[];
  setIntegrationUuids: React.Dispatch<React.SetStateAction<string[]>>;
  resetFilter: () => void;
}

export default function BusinessControlsInput({
  setSelectedStatus,
  selectedStatus,
  integrationUuids,
  setIntegrationUuids,
  applyFilter,
  resetFilter,
}: BusinessControlsProps): JSX.Element {
  const classes = useStyle();
  const { t } = useTranslation();

  return (
    <>
      <Status selectedStatus={selectedStatus} handleSelected={setSelectedStatus} />
      <RelatedIntegrations selections={integrationUuids} handleSelection={setIntegrationUuids} />
      <RailzButton
        size="medium"
        label={t('DASHBOARD_BUSINESS_LIST_CTA_APPLY')}
        className={classes.ctaButton}
        // TODO: fix isDisabled not blocking the calling of the onClick function.
        onClick={applyFilter}
        data-testid="business-controls-filter-apply"
      />

      <RailzButton
        size="medium"
        type="reset"
        label={t('DASHBOARD_BUSINESS_LIST_CTA_RESET')}
        className={classes.ctaButton}
        onClick={resetFilter}
        data-testid="business-controls-filter-clear"
      />
    </>
  );
}
